import { gql } from "@apollo/client";

export const cardsSaving = gql`
query getFanStripePaymentDetails {
    getFanStripePaymentDetails {
    data
    }
    }
`;
